const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/importacao-de-notas-conceitos-faltas-de-alunos-transferidos",
    name: "importacao-de-notas-conceitos-faltas-de-alunos-transferidos",
    meta: {
      allowedPermissions: ["importar_notas_alunos_transferidos"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ImportacaoDeNotasConceitosFaltasDeAlunosTransferido/ImportacaoDeNotasConceitosFaltasDeAlunosTransferido.vue"
      ),
  },
  {
    path: "/importacao-de-notas-conceitos-faltas-de-alunos-transferidos/:alunoId/",
    name: "importacao-de-notas-conceitos-faltas-de-alunos-transferidos-aluno",
    meta: {
      allowedPermissions: ["importar_notas_alunos_transferidos"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ImportacaoDeNotasConceitosFaltasDeAlunosTransferido/ImportacaoDeNotasConceitosFaltasDeAlunosTransferidoAluno.vue"
      ),
  },
];

export default routes;
